import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { BrowserRouter } from 'react-router-dom';
import AuthUrlSync from './components/AuthUrlSync';
import PageLoader from './components/PageLoader';
import { store, persistor } from './store';
import App from './App';
import './styles/main.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

function AppTree() {
  return (
    <>
      <AuthUrlSync />
      <App />
    </>
  );
}

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        {persistor ? (
          <PersistGate loading={<PageLoader />} persistor={persistor}>
            <AppTree />
          </PersistGate>
        ) : (
          <AppTree />
        )}
      </Provider>
    </BrowserRouter>
  </React.StrictMode>,
);
